import { createContext, useContext } from "react";

/** A design selected for the campaign, kept in builder-local state for display. */
export interface DesignView {
  id: string;
  designName: string;
  format?: string;
  thumbnailUrl?: string;
  s3Link?: string;
  addressBox?: boolean;
}

export interface DesignSelection {
  selectedDesign: DesignView | null;
  setSelectedDesign: (design: DesignView | null) => void;
}

// Shared selection context for the Flyering/D2D design step. The mount owns the
// state (so step navigation can read "has a design") and provides it here.
export const DesignSelectionContext = createContext<DesignSelection>({
  selectedDesign: null,
  setSelectedDesign: () => undefined,
});

export const useDesignSelection = (): DesignSelection => useContext(DesignSelectionContext);
